import styles from './loading.module.scss'

export default function LoadingProgress() {
  return <div className={styles.loading} />
}
